"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actualiseStatuses = exports.getAllStatuses = exports.actualiseUnlockedElements = exports.actualiseLockedElements = exports.getAncestors = exports.getDescendants = exports.BFS = exports.makeGraphFromData = exports.preprocessData = void 0;
let preprocessData = (params, idModule) => {
    const ModuleData = params["graph"]["graph"];
    const objectives = ModuleData[idModule]["subgroups"][0];
    const requirements = ModuleData[idModule]["requirements"][0];
    const requirementsKeys = Object.keys(requirements);
    const initSSB = ModuleData[idModule]["init_ssb"][0];
    var initiallyOpenedObjectives = [];
    for (let idx = 0; idx < initSSB.length; idx++) {
        initiallyOpenedObjectives.push(objectives[initSSB[idx]]);
    }
    var preprocessedData = {};
    for (let i = 0; i < objectives.length; i++) {
        const obj = objectives[i];
        preprocessedData[obj] = {};
        preprocessedData[obj]["subgroups"] = ModuleData[obj]["subgroups"][0];
        preprocessedData[obj]["requirements"] = [];
        if (requirementsKeys.includes(obj)) {
            const objRequirements = requirements[obj];
            for (let objRequired of Object.keys(objRequirements)) {
                const requiredLevel = objRequirements[objRequired]["lvl"][0];
                preprocessedData[obj]["requirements"].push([ModuleData[objRequired]["subgroups"][0][requiredLevel], objRequirements[objRequired]["sr"][0]]);
            }
        }
        for (let j = 0; j < preprocessedData[obj]["subgroups"]; j++) {
            const act = preprocessedData[obj]["subgroups"][j];
            if (requirementsKeys.includes(act)) {
                preprocessedData[act]["subgroups"] = [];
                preprocessedData[act]["requirements"] = [];
                const actRequirements = requirements[act];
                for (let objRequired of actRequirements.keys()) {
                    const requiredLevel = actRequirements[objRequired]["lvl"][0];
                    preprocessedData[act]["requirements"].push([ModuleData[objRequired]["subgroups"][0][requiredLevel], actRequirements[objRequired]["sr"][0]]);
                }
            }
        }
    }
    preprocessedData[idModule] = { "requirements": [], "subgroups": initiallyOpenedObjectives };
    return preprocessedData;
};
exports.preprocessData = preprocessData;
let makeGraphFromData = (params, idModule) => {
    const ModuleData = params["graph"]["graph"];
    const preprocessedData = (0, exports.preprocessData)(params, idModule);
    var graph = {};
    for (let node of Object.keys(preprocessedData)) {
        if (node == idModule) {
            graph[node] = { "parents": [], "children": preprocessedData[idModule]["subgroups"], "status": -1 };
        }
        else {
            const subgroups = preprocessedData[node]["subgroups"];
            if (subgroups.length != 0) {
                const initActIndices = ModuleData[node]["init_ssb"][0];
                const maxIdx = Math.max(initActIndices);
                var initAct = [];
                for (let ii = 0; ii < initActIndices.length; ii++) {
                    initAct.push(ModuleData[node]["subgroups"][0][initActIndices[ii]]);
                    graph[ModuleData[node]["subgroups"][0][initActIndices[ii]]] = { "children": [subgroups[maxIdx + 1]], "parents": [node], "status": -1 };
                }
                const requirements = preprocessedData[node]["requirements"];
                graph[node] = { "children": initAct, "parents": [], "status": -1 };
                graph[subgroups[maxIdx + 1]] = { "children": [subgroups[maxIdx + 2]], "parents": initAct, "status": -1 };
                for (let i = maxIdx + 2; i < subgroups.length - 1; i++) {
                    graph[subgroups[i]] = { "children": [subgroups[i + 1]], "parents": [subgroups[i - 1]], "status": -1 };
                }
                graph[subgroups[subgroups.length - 1]] = { "children": [], "parents": [subgroups[subgroups.length - 2]], "status": -1 };
                for (let j = 0; j < requirements.length; j++) {
                    graph[requirements[j][0]]["children"].push(node);
                    graph[node]["parents"].push(requirements[j][0]);
                    if (!Object.keys(graph[node]).includes("unlockSuccessRate")) {
                        graph[node]["unlockSuccessRate"] = [];
                    }
                    graph[node]["unlockSuccessRate"].push(requirements[j][1]);
                }
            }
        }
    }
    for (let initObj of preprocessedData[idModule]["subgroups"]) {
        graph[initObj]["parents"].push(idModule);
    }
    return graph;
};
exports.makeGraphFromData = makeGraphFromData;
let BFS = (graph, node) => {
    var queue = [node];
    var visited = [node];
    while (queue.length > 0) {
        var s = queue.pop();
        if (s) {
            for (let neighbour of graph[s]["children"]) {
                if (!visited.includes(neighbour)) {
                    visited.push(neighbour);
                    queue.push(neighbour);
                }
            }
        }
    }
    return visited;
};
exports.BFS = BFS;
let getDescendants = (graph, idNode) => {
    return (0, exports.BFS)(graph, idNode);
};
exports.getDescendants = getDescendants;
let getAncestors = (graph, idNode) => {
    if (graph[idNode]["parents"].length == 0) {
        return [idNode];
    }
    return [idNode].concat(...graph[idNode]["parents"].map(function (id) { return (0, exports.getAncestors)(graph, id); }));
};
exports.getAncestors = getAncestors;
let actualiseLockedElements = (graph, lockedElements) => {
    for (let ID of Object.keys(graph)) {
        if (lockedElements.includes(ID)) {
            graph[ID]["status"] = 3;
        }
    }
};
exports.actualiseLockedElements = actualiseLockedElements;
let actualiseUnlockedElements = (graph, unlockedElements) => {
    for (let ID of Object.keys(graph)) {
        if (unlockedElements.includes(ID)) {
            graph[ID]["status"] = -1;
        }
    }
};
exports.actualiseUnlockedElements = actualiseUnlockedElements;
let getAllStatuses = (graph) => {
    var statusDict = {};
    for (let node of Object.keys(graph)) {
        statusDict[node] = graph[node]["status"];
    }
    return statusDict;
};
exports.getAllStatuses = getAllStatuses;
let actualiseStatuses = (data, graph, ModuleDiag, idModule) => {
    const ModuleData = data["config"]["ai"]["moduleConfig"][idModule];
    for (let ID of Object.keys(ModuleDiag["param_state"])) {
        if (ID != idModule) {
            const indexObj = ModuleData[idModule]["subgroups"][0].indexOf(ID);
            graph[ID]["status"] = ModuleDiag["param_state"][idModule][0][indexObj];
            for (let i = 0; i < ModuleDiag["param_state"][ID][0].length; i++) {
                graph[ModuleData[ID]["subgroups"][0][i]]["status"] = ModuleDiag["param_state"][ID][0][i];
            }
        }
    }
};
exports.actualiseStatuses = actualiseStatuses;
